export * from './projects.constants';
export * from './predictors.constants';
export const DATA_GRID_PAGE_SIZE = 24;
export const DATA_GRID_PAGE_SIZE_OPTIONS = [9, 24, 48];
export const PREDICTION_OPJECT_TYPE = {
    PROJECT: 'PROJECT',
    PREDICTOR: 'PREDICTOR',
    DATASET: 'DATASET',
    MPO_PROJECT: 'MPO_PROJECT',
}

export const OBJECT_TYPE = {
    ...PREDICTION_OPJECT_TYPE,
    CLUSTERING: 'CLUSTERING',
    FOLDER: 'FOLDER',
    FILE_STORAGE: 'FILE_STORAGE',
}

export const PROJECT_STATUS = {
    NEW: 'NEW',
    RUNNING: 'RUNNING',
    FAILED: 'FAILED',
    COMPLETE: 'COMPLETE',
    CANCELED: 'CANCELED',
    CANCELING: 'CANCELING',
    DELETING: 'DELETING'
}

export const PREDICTOR_STATUS = {
    NEW: 'NEW',
    TRAINING: 'TRAINING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED',
    CANCELING: 'CANCELING',
    DELETING: 'DELETING'
}

export const DATASET_STATUS = {
    CREATED: 'CREATED',
    PREPARING: 'PREPARING',
    FAILED: 'FAILED',
    COMPLETED: 'COMPLETED',
    CANCELING: 'CANCELING',
    PREPARING_IN_AI: 'PREPARING_IN_AI',
    DELETING: 'DELETING'
}

export const FOLDER_STATUS = {
    CREATED: 'CREATED',
    DELETING: 'DELETING',
    DELETED: 'DELETED'
}

export const ACCESS_TYPE = {
    OWNED: 'OWNED',
    SHARED: 'SHARED',
    PUBLIC: 'PUBLIC',
};

export const OWNERSHIP_TYPE = {
    ALL: 'ALL',
    OWNED: 'OWNED',
    NOT_OWNED: 'NOT_OWNED',
}

export const SHARING_STATUS = {
    ALL: 'ALL',
    OWNED: "OWNED",
    OWNED_AND_SHARED_WITH_USERS: 'OWNED_AND_SHARED_WITH_USERS',
    OWNED_AND_PUBLIC: "OWNED_AND_PUBLIC",
    NOT_OWNED: "NOT_OWNED",
    NOT_OWNED_SHARED_WITH_USER: "NOT_OWNED_SHARED_WITH_USER",
    NOT_OWNED_PUBLIC: "NOT_OWNED_PUBLIC",
}

export const DESIRABILITY = {
    MAXIMIZE: 'MAXIMIZE',
    MINIMIZE: 'MINIMIZE',
    EQUAL_DISTRIBUTION: 'EQUAL_DISTRIBUTION',
}


export const PAGE_TYPE = {
    VIEW: 'view',
    LIST: 'list',
}

export const PROJECT_TYPE = {
    PREDICTION: 'PREDICTION',
    CLUSTERING: 'CLUSTERING',
}

export const USAGE_STATUS = {
    DRAFT: { value: 1, label: 'In Progress' },
    SUCCESS: { value: 2, label: 'Success' },
    FAILED: { value: 3, label: 'Failed' },
    CANCELLED: { value: 4, label: 'Cancelled' },
}

export const USAGE_TYPE = {
    PREDICTION: { value: 1, label: 'Prediction' },
    TRAINING: { value: 2, label: 'Training' },
    PREDICT_SMILES: { value: 3, label: 'Predict Smiles' }
}

export const PLATFORM_OBJECT_TYPE = {
    DATASET: { value: 1, label: 'Dataset' },
    PREDICTOR: { value: 2, label: 'Predictor' },
    PROJECT: { value: 3, label: 'Project' },
    MPO_PROJECT: { value: 4, label: 'MPO Project' },
    FOLDER: { value: 5, label: 'FOLDER' }
}

export const BILLING_TYPE = {
    prediction: 'prediction',
    training: 'training'
}
export const BILLING_CONFIG_TYPE = {
    predictor: 'predictor',
    enterprise: 'enterprise'
}

export const OBJECT_TYPE_BY_ID = {
    "1": "DATASET",
    "2": "PREDICTOR",
    "3": "PROJECT",
    "4": "MPO_PROJECT",
    "5": "FOLDER"
 }

 export const DEL_DELIVERY_TYPE = {
        DEL_CORE : "DELCore",
        DEL_FLEX : "DELFlex",
        HIT_MINER : "HitMiner",
        DEL_ABILITY : "DELAbility"
 }

 export const NOT_DEL_DELIVERY_TYPE = {
    NOT_DEL_DELIVERY: "Not_Del_Delivery"
 }

 export const WORKFLOW_STATUS = {
    CREATED: 'CREATED',
    RUNNING: 'RUNNING',
    START: 'START',
    SUSPEND: 'SUSPEND',
    CANCELLED: 'CANCELLED',
    END: 'END'
 }